import { render, staticRenderFns } from "./m-garan-label.vue?vue&type=template&id=62401527&scoped=true&"
import script from "./m-garan-label.vue?vue&type=script&lang=js&"
export * from "./m-garan-label.vue?vue&type=script&lang=js&"
import style0 from "./m-garan-label.vue?vue&type=style&index=0&id=62401527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62401527",
  null
  
)

export default component.exports